const API_PATH_CREATE = 'restaurant/create';
const API_PATH_INDEX = 'restaurant/';

export default {
  namespaced: true,
  state: {
    restaurants: {
      data: [],
      loading: false,
      current_page: 0,
      last_page: 0,
      total: 0
    },
    city: null,
  },
  getters: {
    getRestaurants: (state) => {
      return state.restaurants.data;
    },
    getCurrentPage: (state) => {
      return state.restaurants.current_page;
    },
    getLastPage: (state) => {
      return state.restaurants.last_page;
    },
    getTotalRestaurants: (state) => {
      return state.restaurants.total
    },
    getActiveCity: (state) => {
      return state.city;
    },
    isLoading: (state) => {
      return state.restaurants.loading;
    },
    setPreloader : (state) => {
      return state.restaurants.loading && state.restaurants.current_page == 0;
    },
    preloaderNextPage : (state) => {
      return state.restaurants.loading && state.restaurants.current_page > 0;
    },
    isLastPage : (state) => {
      return state.restaurants.last_page == state.restaurants.current_page;
    }
  },
  mutations: {
    resetResults: (state, payload) => {
      return new Promise(resolve => {
        state.restaurants.data = [];
        state.restaurants.current_page = 0;
        state.restaurants.last_page = 0;
        state.restaurants.total = 0;
        resolve();
      })

    },
  },
  actions: {
    removeRestaurants(store, payload){
      return new Promise((resolve, reject) => {
        if(!payload.id){
          return;
        }

        axios.delete(API_PATH_INDEX+payload.id)
          .then(({data}) => {
            store.dispatch('loadRestaurants')
            resolve(data)
          })
          .catch(error => {
            reject(error)
          })
      });
    },
    getRestaurant(store, payload){
      return new Promise((resolve, reject) => {
        if(!payload.id){
          return;
        }

        axios.get(API_PATH_INDEX+payload.id)
          .then(({data}) => {
            resolve(data)
          })
          .catch(error => {
            reject(error)
          })
      });
    },
    createRestaurant(store, payload){
      return new Promise((resolve, reject) => {
        let url = API_PATH_CREATE;
        let method = 'post';

        if (payload.id) {
          method = 'put';
          url = API_PATH_INDEX + payload.id
        }

        let data = {
          title : payload.title,
          website : payload.website,
          address : payload.address,
          contacts : payload.contacts,
          isActive : payload.isActive,
          sortOrder : payload.sortOrder,
          users : payload.users,
          telegramChatId : payload.telegramChatId
        };

        axios[method](url, data)
          .then(({data}) => {
            resolve(data)
          })
          .catch(error => {
            reject(error)
          })
      });
    },
    loadRestaurants(store, payload) {
      return new Promise((resolve, reject) => {
        let nextPage = store.getters.getCurrentPage + 1;

        if (store.getters.getLastPage && nextPage > store.getters.getLastPage) {
          return resolve();
        }

        if(store.getters.isLoading){
          return resolve();
        }

        bus.$emit('onProgressLinear');
        store.state.restaurants.loading = true;

        let data = {};
        data.page = nextPage;
        return axios.get(API_PATH_INDEX, {
          params: data,
        })
          .then(({data}) => {
            store.state.restaurants.data = (store.getters.getCurrentPage) ? store.getters.getRestaurants.concat(data.data) : data.data
            store.state.restaurants.loading = false;
            setTimeout(() => {
              bus.$emit('offProgressLinear');
            }, 1000)
            resolve(data);
          })
      });
    },
    resetResults(store,payload){
      return new Promise((resolve,reject) => {
        store.commit('resetResults');
        resolve();
      });
    },
    setSearchQuery(store,search){
      return new Promise(resolve =>{
        store.commit('setSearchQuery',search);
        resolve();
      });
    }
  }
}
